import { memo, useState } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import ClosedTaskCard from "@coworker/apprestructured/src/task-management/components/TaskCard/variants/ClosedTaskCard/ClosedTaskCard";
import ListableTaskCardWrapper from "@coworker/apprestructured/src/task-management/components/TaskCard/wrappers/NormalTaskWrapper/ListableTaskCardWrapper";
import { LOADING } from "@coworker/apprestructured/src/task-management/loading";
import { formatDateByLocale } from "@coworker/reusable/formatters/date.formatter";

function ClosedTaskCardDemo() {
  const [taskType, setTaskType] = useState("Custom task");
  const [assigned, setAssigned] = useState("John Lovén");
  const [date, setDate] = useState(
    `Closed ${formatDateByLocale("2025-10-16")}`
  );
  const [priority, setPriority] = useState(true);
  const [safetyAlarm, setSafetyAlarm] = useState(false);
  const [loadingTaskType, setLoadingTaskType] = useState(false);
  const [loadingAssigned, setLoadingAssigned] = useState(false);
  const [loadingDate, setLoadingDate] = useState(false);

  return (
    <Demo>
      <Name>ClosedTaskCard (listable)</Name>
      <Highlight>
        <ListableTaskCardWrapper>
          <ClosedTaskCard
            taskType={loadingTaskType ? LOADING : taskType}
            assigned={loadingAssigned ? LOADING : assigned}
            date={loadingDate ? LOADING : date}
            priority={priority}
            safetyAlarm={safetyAlarm}
          >
            fragments
          </ClosedTaskCard>
        </ListableTaskCardWrapper>
      </Highlight>
      <Actions>
        <FixaInputField
          label="taskType"
          type="text"
          id="closedtaskcarddemo-taskType"
          value={taskType}
          onChange={(e) => setTaskType(e.target.value)}
        />
        <FixaInputField
          label="assigned"
          type="text"
          id="closedtaskcarddemo-assigned"
          value={assigned}
          onChange={(e) => setAssigned(e.target.value)}
        />
        <FixaInputField
          label="date"
          type="text"
          id="closedtaskcarddemo-date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
        <FixaCheckbox
          id="closedtaskcarddemo-priority"
          label="priority"
          checked={priority}
          value="closedtaskcarddemo-priority"
          onChange={() => setPriority((prev) => !prev)}
        />
        <FixaCheckbox
          id="closedtaskcarddemo-safetyAlarm"
          label="safetyAlarm"
          checked={safetyAlarm}
          value="closedtaskcarddemo-safetyAlarm"
          onChange={() => setSafetyAlarm((prev) => !prev)}
        />
        <FixaCheckbox
          id="closedtaskcarddemo-loadingTaskType"
          label="loadingTaskType"
          checked={loadingTaskType}
          value="closedtaskcarddemo-loadingTaskType"
          onChange={() => setLoadingTaskType((prev) => !prev)}
        />
        <FixaCheckbox
          id="closedtaskcarddemo-loadingAssigned"
          label="loadingAssigned"
          checked={loadingAssigned}
          value="closedtaskcarddemo-loadingAssigned"
          onChange={() => setLoadingAssigned((prev) => !prev)}
        />
        <FixaCheckbox
          id="closedtaskcarddemo-loadingDate"
          label="loadingDate"
          checked={loadingDate}
          value="closedtaskcarddemo-loadingDate"
          onChange={() => setLoadingDate((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(ClosedTaskCardDemo);
